var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18997_206",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18997_206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 44C21.2333 44 18.6333 43.475 16.2 42.425C13.7667 41.375 11.65 39.95 9.85 38.15C8.05 36.35 6.625 34.2333 5.575 31.8C4.525 29.3667 4 26.7667 4 24C4 21.2333 4.525 18.6333 5.575 16.2C6.625 13.7667 8.05 11.65 9.85 9.85C11.65 8.05 13.7667 6.625 16.2 5.575C18.6333 4.525 21.2333 4 24 4C26.7667 4 29.3667 4.525 31.8 5.575C34.2333 6.625 36.35 8.05 38.15 9.85C39.95 11.65 41.375 13.7667 42.425 16.2C43.475 18.6333 44 21.2333 44 24V40C44 41.1 43.6083 42.0417 42.825 42.825C42.0417 43.6083 41.1 44 40 44H24ZM24 40C28.4667 40 32.25 38.45 35.35 35.35C38.45 32.25 40 28.4667 40 24C40 19.5333 38.45 15.75 35.35 12.65C32.25 9.55 28.4667 8 24 8C19.5333 8 15.75 9.55 12.65 12.65C9.55 15.75 8 19.5333 8 24C8 24.7667 8.05 25.5167 8.15 26.25C8.25 26.9833 8.4 27.7 8.6 28.4L16 21L22.6 26.55L29.15 20H26V16H36V26H32V22.85L22.8 32L16.25 26.4L10.35 32.3C11.75 34.6 13.6417 36.4583 16.025 37.875C18.4083 39.2917 21.0667 40 24 40ZM39 41C39.5667 41 40.0417 40.8083 40.425 40.425C40.8083 40.0417 41 39.5667 41 39C41 38.4333 40.8083 37.9583 40.425 37.575C40.0417 37.1917 39.5667 37 39 37C38.4333 37 37.9583 37.1917 37.575 37.575C37.1917 37.9583 37 38.4333 37 39C37 39.5667 37.1917 40.0417 37.575 40.425C37.9583 40.8083 38.4333 41 39 41Z",
    fill: "#00E378"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDora);
export default __webpack_public_path__ + "static/media/dora.51520e6af75fa752ba1229dfe5014440.svg";
export { ForwardRef as ReactComponent };